<template>
  <v-text-field
    :loading="loading"
    :value="computedValue.figure"
    @input="updateValue"
    label="Household Size"
    type="number"
    :suffix="computedValue.type"
  ></v-text-field>
</template>

<script>
import axios from "axios";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({ figure: 0, type: "Lookup" }),
    },
    iso3: String,
    year: Number,
  },
  data() {
    return {
      loading: false,
      figure: 0,
    };
  },
  computed: {
    computedValue() {
      return this.value || { figure: 0, type: "Lookup" };
    },
  },
  watch: {
    async iso3() {
      await this.fetchHouseholdSize();
    },
    async year() {
      await this.fetchHouseholdSize();
    },
  },
  methods: {
    async fetchHouseholdSize() {
      console.debug("fetchHouseholdSize()");
      this.loading = true;
      try {
        let response = await axios.get("/psql/household_sizes", {
          params: {
            iso3: `eq.${this.iso3}`,
            year: `eq.${this.year}`,
          },
          headers: {
            Accept: "application/vnd.pgrst.object+json",
          },
        });
        this.$emit("input", { figure: response.data.size, type: "Lookup" });
      } catch (error) {
        this.$emit("input", { figure: 0, type: "Not Found" });
      }
      this.loading = false;
    },
    updateValue(value) {
      console.log(value);
      if (value === "") {
        this.fetchHouseholdSize();
        return;
      }
      this.$emit("input", { figure: value, type: "Manual" });
    },
  },
};
</script>

<style scoped></style>
